import { basePaintProperty, 
        allLayersColorProperty, 
        paintProperties, 
        ColorAttributes } from "../../constants/constants";
import { calculateStatusColor,
        calculateAverageProgress, 
        calculateAverageDelay,
        calculatePaidPhysicalProgress, 
        calculateHistoricalObservations,
        calculateDates} from "../cardsGroupsFeatures";

function getPaintProperty(featureAttribute) {
    const paintProperty = paintProperties[featureAttribute];
    return [...basePaintProperty, paintProperty];
}

function setFeaturesColor(map, props, featureAttribute) {
    for (const [levelId, featuresGroup] of Object.entries(props.featuresGroups)) {
        if (props.filters.levelIds.length > 0 && !props.filters.levelIds.includes(parseInt(levelId))) continue;
        let stageId = props.projectData.levels[levelId].attributes.stage_id;
        if (props.filters.stageIds.length > 0 && !props.filters.stageIds.includes(stageId)) continue;
        for (const feature of featuresGroup) {
            setFeatureColor(map, props, feature, featureAttribute);
        }
    }
}

function setFeatureColor(map, props, feature, featureAttribute) {
    let stateValue = null;
    if (featureAttribute === ColorAttributes.STATUS) {
        stateValue = calculateStatusColor(props, map.filters, feature);
    } else if (featureAttribute === ColorAttributes.PROGRESS) {
        stateValue = calculateAverageProgress(props, map.filters, feature);
    } else if (featureAttribute === ColorAttributes.DELAYED) {
        stateValue = calculateAverageDelay(props, map.filters, feature);
    } else if (featureAttribute === ColorAttributes.PAID_PHYSICAL_PROGRESS) {
        stateValue = calculatePaidPhysicalProgress(props, map.filters, feature);
    } else if (featureAttribute === ColorAttributes.HISTORICAL_OBSERVATIONS) {
        stateValue = calculateHistoricalObservations(props, map.filters, feature);
    } else if (featureAttribute === ColorAttributes.DATES) {
        stateValue = calculateDates(props, map.filters, feature);
    }
    map.setFeatureState({ 
        id: feature.id,
        source: 'cards'
    }, { 
        [featureAttribute]: stateValue 
    });
}

export function handleFeaturesPaint(map, props, featureAttribute) {
    const paintProperty = getPaintProperty(featureAttribute);
    for (const [layer, color] of Object.entries(allLayersColorProperty)) {
        map.setPaintProperty(layer, color, paintProperty);
    }
    if (featureAttribute !== ColorAttributes.CARD_CATEGORY) {
        setFeaturesColor(map, props, featureAttribute);
    }
}